<template>
  <main :class="$style.mainContent">
    <slot />
  </main>
</template>

<style lang="scss" module>
@layer legacy-views {

  .mainContent {
    background: var(--color-bg-primary);
    border-radius: $border-radius;
  }

}</style>
